<template>
  <v-container id="faq">
    <div class="d-flex flex-column ga-5 text-center">
      <div class="mb-1">
        <v-chip
          color="gray-300"
          variant="outlined"
          text="Odpowiedzi"
        />
      </div>
      <div class="text-h3">
        O to pytacie najczęściej
      </div>
      <div
        class="text-subtitle-1 text-gray-500 font-weight-regular mx-auto"
        :style="{ maxWidth: '550px'}"
      >
        Jeżeli nie znajdziesz odpowiedzi na swoje pytanie,
        śmiało możesz napisać do naszego teamu na kontakt@csmonline.edu.pl
      </div>
    </div>
    <v-expansion-panels
      flat
      eager
      class="my-16 mx-auto"
      :style="{ maxWidth: '1200px' }"
    >
      <v-expansion-panel title="Czy rejestracja w CSM/online jest darmowa?">
        <template #text>
          Rejestrując się zakładasz konto #Basic – darmowy, podstawowy wariant, dzięki któremu otrzymujesz dostęp do wszystkich tekstów piosenek na platformie i wybranych przez nas tutoriali. W każdej chwili możesz zmienić plan na #Solo lub #Team, aby uzyskać pełny dostęp do bazy tutoriali, opracowań, nauczań i pozostałych treści. Szczegółowe informacje o planach znajdziesz w zakładce „Subskrypcje” na twoim koncie.
        </template>
      </v-expansion-panel>
      <v-expansion-panel title="Jak działa plan #Team i do kogo jest skierowany?">
        <template #text>
          <div class="d-flex flex-column ga-2">
            <p>Plan #Team stworzyliśmy z myślą o grupach uwielbienia w lokalnych kościołach, jak również o liderach odpowiedzialnych za uwielbienie na konferencjach, obozach i wydarzeniach międzykościelnych.</p>
            <p>Użytkownik wybierający ten plan staje się liderem grupy i decyduje o jej wielkości (od 5 do 100 miejsc) oraz sposobie płatności. Jako moderator ma pełną swobodę w zarządzaniu zespołem – może dowolnie dodawać i wymieniać członków w trakcie trwania subskrypcji</p>
          </div>
        </template>
      </v-expansion-panel>
      <v-expansion-panel title="Czy mogę udostępniać swoje konto #Solo innym osobom?">
        <template #text>
          Plan #Solo skierowany jest do osób, które chcą indywidualnie rozwijać się w uwielbieniu. Konto jest przypisane do jednego użytkownika i nie może być współdzielone.
        </template>
      </v-expansion-panel>
      <v-expansion-panel title="Co zrobić, jeśli potrzebuję akordów w innej tonacji?">
        <template #text>
          Jeśli potrzebujesz opracowania akordów w tonacji innej niż dostępne na platformie, napisz do nas na adres: kontakt@csmonline.edu.pl.
        </template>
      </v-expansion-panel>
      <v-expansion-panel title="Czy mogę mieć kilka subskrypcji na jednym koncie?">
        <template #text>
          Tak, masz pełną dowolność. Do jednego konta możesz mieć przypisaną zarówno subskrypcję indywidualną #Solo, jak i zarządzać wieloma grupami w ramach planów #Team (np. prowadząc osobno zespół młodzieżowy i chór).
        </template>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>
